export default {
  FULL: 1280,
  NORMAL: 848,
};
